export const GraphEndpoint = {
  GET_AVAILABLE_CHARTS_WITH_CATEGORIES: '/default/index/get-available-charts-with-categories',
  GRAPH: '/default/static/graph',
  GRAPH_WITH_ADDITIONAL_INFO: '/default/static/graph-with-additional-info',
  GRAPH_WITH_TABLE: '/default/static/graph-with-table',
  EVALUATION_ALARM_GRAPH: '/evaluation/alarm/graph',
  EVALUATION_DEFAULT_GRAPH: '/evaluation/default/graph',
  EVALUATION_PARK_GRAPH: '/evaluation/park/graph',
  EVALUATION_USER_GRAPH: '/evaluation/user/graph',
  EVALUATION_USER_GRAPH_WITH_TABLE: '/evaluation/user/graph-with-table',
  EVALUATION_DEFAULT_GRAPH_WITH_TABLE: '/evaluation/default/graph-with-table',
  EVALUATION_CUSTOM_GRAPH_WITH_TABLE: '/evaluation/custom/graph-with-table',
  SAVE_CUSTOM_GRAPH: '/evaluation/custom/save-custom-graph',
  EDIT_CUSTOM_GRAPH: '/evaluation/custom/edit-custom-graph',
  DELETE_CUSTOM_GRAPH: '/evaluation/custom/delete-custom-graph',
  RENAME_CUSTOM_GRAPH: '/evaluation/custom/rename-custom-graph',
  LOAD_CUSTOM_GRAPHS: '/evaluation/custom/load-custom-graphs',
  LOAD_DIAGRAM_DATA: '/evaluation/custom/load-diagram-data',
  LOAD_ANALYSIS: '/analysis/manage/new',
};
